import * as types from '../../actions/types';

const initialState = null

export default function data (state = initialState, action) {
  switch (action.type) {
    case types.SET_JOURNAL_DATA:
      return action.payload
    
    default:
      return state;
  }
}
